import { SearchMenuRoot } from "./search-menu";
import { SearchMenuEmpty } from "./parts/view-empty";
import { SearchMenuItem } from "./parts/item";
import { SearchMenuList } from "./parts/list";
import { SearchMenuSearch } from "./parts/search";

export { SEARCH_MENU_SEARCH_LABEL } from "./search-menu.messages";
export type * from "./types-search-menu";

/** Menu popup com busca composable (`SearchMenu.Root/Search/List/Item/Empty`): o Prime não tem busca em Menu/TieredMenu. */
export const SearchMenu = {
  Root: SearchMenuRoot,
  Search: SearchMenuSearch,
  List: SearchMenuList,
  Item: SearchMenuItem,
  Empty: SearchMenuEmpty,
};
